// extracted by mini-css-extract-plugin
module.exports = {"root":"SaleSash_root__1U38M","text":"SaleSash_text__2P25H","small":"SaleSash_small__mxmwA","spinAround":"SaleSash_spinAround__2GMl-"};